import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "popup"
};
const _hoisted_2 = {
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $props.show,
    closeable: true,
    onClose: $options.close,
    style: {
      "background": "none"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [[_directive_lazy, $data.img]]), _cache[0] || (_cache[0] = _createElementVNode("div", null, "微信扫一扫 立即体验", -1))])]),
    _: 1
  }, 8, ["show", "onClose"]);
}